import React from "react";
import moment from "moment";
import CmsShimmer from "./skeleton/CmsShimmer";
import { CMS_PAGE_SKELETONS } from "./skeleton";
import { SkeletonLangStatusCards } from "./skeleton/CmsSkeletonPrimitives";

function LangStatus({ label, dirty, updatedAt }) {
  return (
    <div className={`cms-lang-status-card cms-lang-status-card--${label.toLowerCase()}`}>
      <div className="cms-lang-status-card__top">
        <span className={`cms-lang-chip cms-lang-chip--${label.toLowerCase()}`}>{label}</span>
        <span
          className={`cms-status-badge ${
            dirty ? "cms-status-badge--unsaved" : "cms-status-badge--live"
          }`}
        >
          {dirty ? "Unsaved" : "Live"}
        </span>
      </div>
      {updatedAt && (
        <span className="cms-lang-status-card__time">
          <i className="mdi mdi-clock-outline" aria-hidden="true" />
          Last saved {moment(updatedAt).format("D MMM YYYY, h:mm A")}
        </span>
      )}
    </div>
  );
}

function PageHeaderIcon({ pageIconSrc, pageIcon }) {
  if (pageIconSrc) {
    return (
      <span className="cms-page-header__icon cms-page-header__icon--img" aria-hidden="true">
        <img src={pageIconSrc} alt="" className="cms-page-header__icon-img" />
      </span>
    );
  }
  if (pageIcon) {
    return (
      <span className="cms-page-header__icon" aria-hidden="true">
        <i className={`mdi ${pageIcon}`} />
      </span>
    );
  }
  return null;
}

function CmsPageShell({
  title,
  subtitle,
  pageIcon,
  pageIconSrc,
  dirtyEn,
  dirtyEs,
  updatedAtEn,
  updatedAtEs,
  loading,
  skeletonPage,
  children,
}) {
  const SkeletonComponent = skeletonPage ? CMS_PAGE_SKELETONS[skeletonPage] : null;

  return (
    <div className="cms-website__inner">
      <header className="cms-page-header">
        <div className="cms-page-header__main">
          <div className="cms-page-header__title-row">
            <PageHeaderIcon pageIconSrc={pageIconSrc} pageIcon={pageIcon} />
            <div className="cms-page-header__copy">
              {loading ? (
                <>
                  <CmsShimmer className="cms-skeleton__page-title" />
                  <CmsShimmer className="cms-skeleton__page-subtitle" />
                </>
              ) : (
                <>
                  <h1 className="cms-page-title">{title}</h1>
                  {subtitle && <p className="cms-page-subtitle">{subtitle}</p>}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="cms-page-header__status">
          {loading ? (
            <SkeletonLangStatusCards />
          ) : (
            <>
              <LangStatus label="EN" dirty={dirtyEn} updatedAt={updatedAtEn} />
              <LangStatus label="ES" dirty={dirtyEs} updatedAt={updatedAtEs} />
            </>
          )}
        </div>
      </header>

      {loading && SkeletonComponent ? (
        <SkeletonComponent />
      ) : (
        children
      )}
    </div>
  );
}

export default CmsPageShell;
